<template>
  <div>
    <b-table
      striped
      hover
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(actions)="row">
        <b-button
          size="sm"
          @click="selectMember(row.item)"
          class="mr-1"
          variant="primary"
        >
          Select
        </b-button>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  props: { memberResult: Array },
  data() {
    return {
      fields: ["cardid", "firstname", "lastname", "email", "phone", "actions"],
      items: null,
      checkedMember: []
      //hasCheckedIn: false,
    };
  },
  computed: {},
  mounted() {
    this.items = this.memberResult;

    /*
    //console.log(this.memberResult);
    var resultArr = [];
    for (var i = 0; i < this.memberResult.length; i++) {
      let member = this.memberResult[i];
      let memberObj = {
        id: member.id,
        name: member.name,
        email: member.email,
        phone: member.phone,
      };
      resultArr.push(memberObj);
      //console.log(this.memberResult[i].email);
    }
    this.items = resultArr; */
  },
  methods: {
    selectMember(item) {
      //console.log(item);
      let member = {
        id: item.id,
        cardid: item.cardid,
        firstname: item.firstname,
        lastname: item.lastname,
        email: item.email,
        phone: item.phone,
        type: item.type,
      };
      this.$emit("member-created", member);
    }
  }
};
</script>
